import EmptyState, { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';
import * as React from 'react';
import { observer } from 'mobx-react-lite';

import styles from './EmptyState.scss';

export const EventsEmptyState = observer(function EventsEmptyState(props: EmptyStateProps) {
    return (
        <div className={styles.emptyStateContainer}>
            <EmptyState
                {...props}
                classNames={{
                    container: styles.container,
                    mainMessage: styles.mainMessage,
                    detailsMessage: styles.detailsMessage,
                }}
            />
        </div>
    );
});
